import { render, staticRenderFns } from "./AdminInputStockStepper.vue?vue&type=template&id=626a2059&scoped=true&"
import script from "./AdminInputStockStepper.vue?vue&type=script&lang=js&"
export * from "./AdminInputStockStepper.vue?vue&type=script&lang=js&"
import style0 from "./AdminInputStockStepper.vue?vue&type=style&index=0&id=626a2059&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626a2059",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VTextField})
